module.exports = __webpack_public_path__ + "cloud_18_logo.png?4e4753e5cae57781be2f2b3b11d6cf4d";